// libraries
import styled from 'styled-components';

import { Avatar, Badge, Tooltip, Typography } from 'antd';
import { BugFilled, ScheduleOutlined } from '@ant-design/icons';
import * as Colors from '@ant-design/colors';

// services
import { formatDate } from '../../../../utils/date';

import { txt } from '../../../../locales/i18n';
import { useDeviceSize } from '../../../../hooks/device-size';

export function ActivityPageHeader({ activity }: any): JSX.Element {
	const isMobileDevice: boolean = useDeviceSize();
	const imageSource: string = process.env.REACT_APP_ACTIVITY_IMAGE_PATH + activity.imgFilename;

	function renderAvatar(): JSX.Element | null {
		if (isMobileDevice === true) return null;
		const icon: JSX.Element = (
			<Tooltip title={activity?.crawler?.toUpperCase()}>
				<BugFilled style={{ color: Colors.blue.primary }} />
			</Tooltip>
		);

		return (
			<Badge count={activity.crawler && icon}>
				<Avatar size={64} src={imageSource} icon={<ScheduleOutlined />} />
			</Badge>
		);
	}

	return (
		<StyledHeader>
			{renderAvatar()}

			<div className="details-container">
				<h3>
					<Typography.Text ellipsis>{activity.title}</Typography.Text>
					<Typography.Text type="secondary">{activity.municipalityName}</Typography.Text>
				</h3>

				<Tooltip title={`${txt('global.created by')} ${activity.username}`}>
					<Typography.Link ellipsis href={`/users/${activity.user_id}`} className="user-details-container">
						<span>{activity.username}</span>
						<Typography.Text type="secondary">{activity.userMunicipalityName}</Typography.Text>
						<Typography.Text type="secondary">{formatDate(activity.created)}</Typography.Text>
					</Typography.Link>
				</Tooltip>
			</div>
		</StyledHeader>
	);
}

const StyledHeader = styled.section`
	display: flex;
	align-items: center;
	gap: 1em;
	padding: 1rem 2rem;

	.details-container {
		display: flex;
		flex-direction: column;

		h3 {
			margin: 0;
			display: flex;
			gap: 1ch;
		}
	}

	.user-details-container {
		color: ${Colors.blue.primary};
		display: flex;
		gap: 1ch;
	}
`;
